<template>
    <div class="container">
        <div class="container-header">
            <img src="../assets/images/laidan_logo.png" alt="">
            <a href="javascript:void(0)" @click="downloadHandle">{{ $t('clickCheck') }}</a>
        </div>
        <div class="container-main">
            <!--会员卡-->
            <div class="fiche">
                <div class="shell">
                    <div class="list">
                        <div class="card" ref="cardContainer">
                            <div class="card-item"
                                 :style="{width: item.w, height: item.h, left: item.x, top: item.y, 'z-index': item.z, textAlign: item.textAlign, backgroundColor: (item.backgroundColor ? item.backgroundColor : 'transparent'), borderRadius: item.radius, opacity: (item.backgroundColorAlpha ? Number(item.backgroundColorAlpha) : 1)}"
                                 v-for="(item, index) in faceList"
                                 :key="index">
                                <template v-if="item.type === 'background'">
                                    <img
                                        :src="item.image"
                                        style="width: 100%; height: 100%;">
                                </template>
                                <template v-else-if="item.type === 'logo'">
                                    <img
                                        :src="item.image"
                                        style="width: 100%; height: 100%;"
                                        :style="{borderRadius: item.radius}">
                                </template>
                                <template v-else-if="item.type === 'text' || item.type === 'custom'">
                                    <p
                                        class="text"
                                        :style="{color: item.fontColor, fontSize: item.fontSize}">
                                        {{ item.text }}
                                    </p>
                                </template>
                                <template v-else-if="item.type === 'cardNumber'">
                                    <img style="width: 100%; height: 100%;" id="face_barcode">
                                </template>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-item"
                                 :style="{width: item.w, height: item.h, left: item.x, top: item.y, zIndex: item.z, textAlign: item.textAlign, backgroundColor: (item.backgroundColor ? item.backgroundColor : 'transparent'), borderRadius: item.radius, opacity: (item.backgroundColorAlpha ? Number(item.backgroundColorAlpha) : 1)}"
                                 v-for="(item, index) in backList"
                                 :key="index">
                                <template v-if="item.type === 'background'">
                                    <img
                                        :src="item.image"
                                        style="width: 100%; height: 100%;">
                                </template>
                                <template v-else-if="item.type === 'logo'">
                                    <img
                                        :src="item.image"
                                        style="width: 100%; height: 100%;"
                                        :style="{borderRadius: item.radius}">
                                </template>
                                <template v-else-if="item.type === 'text' || item.type === 'custom'">
                                    <p
                                        class="text"
                                        :style="{color: item.fontColor, fontSize: item.fontSize}">
                                        {{ item.text }}
                                    </p>
                                </template>
                                <template v-else-if="item.type === 'cardNumber'">
                                    <img style="width: 100%; height: 100%;" id="back_barcode">
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 优惠券 -->
            <div class="coupon">
                <p class="coupon-title">{{ $t('drawPlatCoupon') }}</p>
                <div class="shell">
                    <div class="card">
                        <div class="card-left">
                            <p class="money">2,00€</p>
                            <p class="text">{{ $t('firLoginDraw') }}</p>
                        </div>
                        <div class="card-right">
                            <a class="draw" href="javascript:void(0);" @click="downloadHandle">
                                <span>{{ $t('clickDown') }}</span>
                                <span>{{ $t('appDraw') }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 广告 -->
            <div class="adver">
                <p class="adver-title">{{ $t('moreDisDis') }}</p>
                <div class="list">
                    <div class="list-item" v-for="item in adverList" :key="item.id">
                        <img :src="item.cover" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// member
import {queryMemberCardInfo, queryMerchantAdPaper} from "@/api";
import JsBarcode from 'jsbarcode'
import {mapState} from "vuex";
import {formatNum, retainPercent} from "@/utils/common";
export default {
    name: 'Member',
    // 组件
    components: {
    
    },
    props: {},
    data () {
        return {
            latitude: '',   // 维度
            longitude: '',   // 经度
            ficheHeight: 190,
            cardNumber: '',
            faceList: [],
            backList: [],
            adverList: [],
        };
    },
    // 计算属性
    computed: {
        ...mapState(['memberCardId']),
    },
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 获取经纬度
        getCoordinate () {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((res) => {
                    this.longitude = res.coords.longitude;
                    this.latitude = res.coords.latitude;
                })
            }
        },
        // 获取会员卡高度
        getFicheHeight () {
            if (this.$refs.cardContainer) {
                this.ficheHeight = this.$refs.cardContainer.offsetHeight
            }
        },
        // 获取会员卡信息
        getCardInfo () {
            let params = {
                id: this.memberCardId
            }
            queryMemberCardInfo(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.cardNumber = res.data.platInfo.cardNumber || '1234567890'
                    const cardStyle = res.data.platInfo.cardStyle
                    if (Object.prototype.hasOwnProperty.call(cardStyle, 'face')) {
                        let faceObj = cardStyle.face
                        let faceList = []
                        let existBarcode = false
                        let barcodeObj = null
                        for (let key in faceObj) {
                            let elementObj = this.getStyleObj(key, faceObj[key])
                            if (key === 'cardNumber') {
                                existBarcode = true
                                barcodeObj = JSON.parse(JSON.stringify(elementObj))
                            }
                            faceList.push(elementObj)
                        }
                        this.faceList = faceList
                        // 条形码
                        if (existBarcode) {
                            this.$nextTick(() => {
                                this.initBarcode(barcodeObj, 'face')
                            })
                        }
                    }
                    if (Object.prototype.hasOwnProperty.call(cardStyle, 'back')) {
                        let backObj = cardStyle.back
                        let backList = []
                        let existBarcode = false
                        let barcodeObj = null
                        for (let key in backObj) {
                            let elementObj = this.getStyleObj(key, backObj[key])
                            if (key === 'cardNumber') {
                                existBarcode = true
                                barcodeObj = JSON.parse(JSON.stringify(elementObj))
                            }
                            backList.push(elementObj)
                        }
                        this.backList = backList
                        // 条形码
                        if (existBarcode) {
                            this.$nextTick(() => {
                                this.initBarcode(barcodeObj, 'back')
                            })
                        }
                    }
                } else {
                    this.$toast.fail(res.msg);
                }
            }).catch(err => {
                this.$toast.fail(err);
            })
        },
        // 获取元素对象
        getStyleObj (name, obj) {
            let elementObj = null
            // 宽
            let w = retainPercent(obj.w, 2)
            // 高
            let h = retainPercent(obj.h, 2)
            // X
            let x = retainPercent(obj.x, 2)
            // Y
            let y = retainPercent(obj.y, 2)
            // 圆角
            let radius = obj.radius ?  Math.round(Number(obj.radius)*this.ficheHeight) : 0
            if (name === 'background') {
                elementObj = {
                    name: name,
                    type: 'background',
                    textAlign: 'left',
                    image: obj.image || '',
                    radius: 0,
                    remark: obj.remark || '',
                    w: '100%',
                    h: '100%',
                    x: 0,
                    y: 0,
                    z: 0,
                }
            } else if (name === 'logo') {
                elementObj = {
                    name: name,
                    type: 'logo',
                    textAlign: 'left',
                    image: obj.image || '',
                    radius: `${radius}px`,
                    remark: obj.remark || '',
                    w: w,
                    h: h,
                    x: x,
                    y: y,
                    z: 9,
                }
            } else if (name === 'merchantName' || name === 'merchantAddress' || name === 'points') {
                let size = Number(obj.fontSize) || 12
                let sizeValue = (this.ficheHeight/190) * size
                let fontSize = formatNum(sizeValue, 0)
                elementObj = {
                    name: name,
                    type: 'text',
                    text: obj.text || '',
                    textAlign: obj.textAlign || 'left',
                    fontSize: `${fontSize}px`,
                    fontColor: obj.fontColor || '#272727',
                    backgroundColor: obj.backgroundColor || '',
                    backgroundColorAlpha: obj.backgroundColorAlpha || '',
                    remark: obj.remark || '',
                    radius: `${radius}px`,
                    w: w,
                    h: h,
                    x: x,
                    y: y,
                    z: 9,
                }
            } else if (name === 'cardNumber') {
                let size = Number(obj.fontSize) || 12
                let sizeValue = (this.ficheHeight/190) * size
                let fontSize = formatNum(sizeValue, 0)
                let hValue = Math.round(obj.h * this.ficheHeight)
                elementObj = {
                    name: name,
                    type: 'cardNumber',
                    text: '1234567890',
                    textAlign: obj.textAlign || 'left',
                    fontSize: `${fontSize}px`,
                    fontColor: obj.fontColor || '#272727',
                    backgroundColor: obj.backgroundColor || '',
                    backgroundColorAlpha: obj.backgroundColorAlpha || '',
                    remark: obj.remark || '',
                    radius: `${radius}px`,
                    hValue: hValue,
                    w: w,
                    h: h,
                    x: x,
                    y: y,
                    z: 9,
                }
            } else {
                let size = Number(obj.fontSize) || 12
                let sizeValue = (this.ficheHeight/190) * size
                let fontSize = formatNum(sizeValue, 0)
                elementObj = {
                    name: name,
                    type: 'custom',
                    text: obj.text || '',
                    textAlign: obj.textAlign || 'left',
                    fontSize: `${fontSize}px`,
                    fontColor: obj.fontColor || '#272727',
                    backgroundColor: obj.backgroundColor || '',
                    backgroundColorAlpha: obj.backgroundColorAlpha || '',
                    remark: obj.remark || '',
                    radius: `${radius}px`,
                    w: w,
                    h: h,
                    x: x,
                    y: y,
                    z: 9,
                }
            }
            return elementObj
        },
        // 初始化条形码
        initBarcode (obj, type) {
            let barcodeOptions = {
                format: "CODE128",//条形码的格式
                width: 2,//线宽
                height: obj.hValue,//条码高度
                lineColor: obj.fontColor,//线条颜色
                displayValue: true,//是否显示文字
                fontSize: obj.fontSize,//设置文本的大小
                margin: 5 //设置条形码周围的空白区域
            }
            if (type === 'face') { // 正面
                JsBarcode("#face_barcode", this.cardNumber, barcodeOptions)
            } else if (type === 'back') { // 背面
                JsBarcode("#back_barcode", this.cardNumber, barcodeOptions)
            }
        },
        
        // 获取商家广告纸
        getMerchantAdPaper () {
            let params = {
                distance: 100000000,
                page: 1,
                size: 10
            }
            if (this.longitude) {
                params.longitude = this.longitude
                params.latitude = this.latitude
            }
            queryMerchantAdPaper(params).then(res => {
                if (Number(res.code) === 20000) {
                    const resData = res.data.list
                    this.adverList = resData.map(item => {
                        return {
                            id: item.id,
                            cover: item.cover
                        }
                    })
                } else {
                    this.$toast.fail(res.msg);
                }
            }).catch(err => {
                this.$toast.fail(err);
            })
        },
        
        // 下载
        downloadHandle () {
            // 判断手机系统
            let userAgent = navigator.userAgent
            if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
                window.location.href = 'laidan://'
                setTimeout(() => {
                    let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                    if (typeof hidden == 'undefined' || hidden === false) {
                        //App store下载地址
                        window.location.href = "https://apps.apple.com/cn/app/laidan/id1545081312";
                    }
                }, 3000);
            } else if (userAgent.includes('Android')) {
                window.location.href = 'laidan://'
                setTimeout(() => {
                    let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                    if (typeof hidden == 'undefined' || hidden === false) {
                        //App store下载地址
                        window.location.href = "https://play.google.com/store/apps/details?id=com.pointsme.laidan";
                    }
                }, 2000);
            }
        }
    },
    // 创建完成
    created () {
        // 获取经纬度
        this.getCoordinate()
    },
    // 挂载完成
    mounted () {
        if (this.memberCardId) {
            // 获取卡片高度
            this.getFicheHeight()
            // 获取会员卡信息
            this.getCardInfo()
            // 获取商家广告纸
            setTimeout(() => {
                this.getMerchantAdPaper()
            }, 300)
        } else {
            this.$router.replace({path: '/404'})
        }
    },
    // 销毁之前
    beforeDestroy () {

    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    padding-top: 52px;
    background-color: #FCFBFD;
    position: relative;
    .container-header{
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        height: 52px;
        padding-left: 24px;
        padding-right: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #FFFFFF;
        box-shadow: 0 3px 6px 1px rgba(0, 0, 0, 0.16);
        img{
            height: 24px;
        }
        a{
            display: flex;
            height: 24px;
            padding-left: 16px;
            padding-right: 16px;
            justify-content: center;
            align-items: center;
            color: #FFFFFF;
            font-size: 12px;
            //background-image: url("../assets/images/mini_btn_bg.png");
            //background-size: 100% 100%;
            background: linear-gradient(90deg, #EC5E29 0%, #EE8D35 100%);
            border-radius: 12px;
        }
    }
    .container-main{
        width: 100%;
        height: 100%;
        padding-top: 24px;
        padding-bottom: 24px;
        overflow-y: auto;
        .fiche{
           padding-left: 24px;
           .shell{
               width: 100%;
               height: 190px;
               position: relative;
               overflow: hidden;
               .list{
                   position: absolute;
                   left: 0;
                   top: 0;
                   right: 0;
                   padding-right: 25px;
                   padding-bottom: 6px;
                   display: flex;
                   overflow-x: scroll;
                   overflow-y: hidden;
                   .card{
                       width: 310px;
                       height: 190px;
                       border-radius: 20px;
                       overflow: hidden;
                       flex-shrink: 0;
                       box-shadow: 0 3px 6px 1px rgba(0, 0, 0, 0.16);
                       margin-right: 12px;
                       position: relative;
                       &:last-of-type {
                           margin-right: 0;
                       }
                       .card-item{
                           position: absolute;
                           span, img{
                               vertical-align: middle;
                           }
                       }
                   }
               }
           }
           
       }
        .coupon{
            margin-top: 24px;
            padding-left: 24px;
            padding-right: 24px;
            .coupon-title{
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 600;
                color: #3C3C43;
            }
            .shell{
                margin-top: 8px;
                width: 100%;
                height: 80px;
                background: linear-gradient(180deg, rgba(236, 95, 41, 0.2) 0%, rgba(237, 139, 52, .2) 100%);
                border-radius: 4px;
                display: flex;
                justify-content: center;
                align-items: center;
                .card{
                    width: 240px;
                    height: 60px;
                    padding-left: 16px;
                    //padding-right: 16px;
                    background-image: url("../assets/images/ticket_bg.png");
                    background-size: 100% 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .card-left{
                        .money{
                            font-size: 15px;
                            font-family: PingFang SC-Regular, PingFang SC;
                            font-weight: 600;
                            color: #EC5E29;
                        }
                        .text{
                            margin-top: 4px;
                            font-size: 10px;
                            font-family: PingFang SC-Regular, PingFang SC;
                            color: #EE8D35;
                        }
                    }
                    .card-right{
                        width: 76px;
                        .draw{
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            text-align: center;
                            span{
                                font-size: 14px;
                                line-height: 21px;
                                font-family: PingFang SC-Regular, PingFang SC;
                                font-weight: 600;
                                color: #EC5E29;
                            }
                        }
                    }
                }
            }
        }
        .adver{
            margin-top: 24px;
            padding-left: 24px;
            padding-right: 24px;
            .adver-title{
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 600;
                color: #3C3C43;
            }
            .list{
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                .list-item{
                    width: 50%;
                    border-radius: 8px;
                    overflow: hidden;
                    box-shadow: 0 3px 6px 1px rgba(0, 0, 0, 0.16);
                    margin-bottom: 12px;
                    &:nth-of-type(2n+1){
                        padding-right: 6px;
                    }
                    &:nth-of-type(2n){
                        padding-left: 6px;
                    }
                    img{
                        width: 100%;
                    }
                }
            }
        }
    }
}
</style>

